// The filter of a file list, as in Sumatra File Manager: every word must be
// in the name, and a name with a "-word" in it is left out. Letter case does
// not matter.

export interface NameFilter {
  include: string[];
  exclude: string[];
}

export function parseNameFilter(text: string): NameFilter {
  let res: NameFilter = { include: [], exclude: [] };
  for (let word of text.toLowerCase().split(/\s+/)) {
    if (word == "") {
      continue;
    }
    if (word.startsWith("-")) {
      // a lone "-" is a word being typed, not a rule yet
      if (word.length > 1) {
        res.exclude.push(word.substring(1));
      }
      continue;
    }
    res.include.push(word);
  }
  return res;
}

export function nameFilterIsEmpty(f: NameFilter): boolean {
  return f.include.length == 0 && f.exclude.length == 0;
}

export function nameFilterMatches(f: NameFilter, name: string): boolean {
  name = name.toLowerCase();
  for (let word of f.include) {
    if (!name.includes(word)) {
      return false;
    }
  }
  for (let word of f.exclude) {
    if (name.includes(word)) {
      return false;
    }
  }
  return true;
}

// Returns the rows whose name passes the filter, all of them for an empty
// filter.
export function filterByName<T extends { name: string }>(rows: T[], text: string): T[] {
  let f = parseNameFilter(text);
  if (nameFilterIsEmpty(f)) {
    return rows;
  }
  return rows.filter((r) => nameFilterMatches(f, r.name));
}
